import { Flex, Image, useToast } from '@chakra-ui/react';
import { useEffect } from 'react';
import logbookIcon from '../../../assets/logbook-icon.svg';
import { icon } from './styles';
import Footer from './components/Footer';
import EmailPasswordInput from './components/EmailPasswordInput';

const Login = () => {
  const toast = useToast();

  useEffect(() => {
    let expired = false;
    try {
      expired = sessionStorage.getItem('session_expired') === '1';
      sessionStorage.removeItem('session_expired');
    } catch {
      // abaikan
    }
    if (!expired) return;

    toast({
      title: 'Sesi login berakhir',
      description:
        'Silakan login kembali. Isian form kasus yang belum terkirim sudah disimpan sebagai draft dan akan dipulihkan.',
      status: 'warning',
      position: 'top',
      duration: 12000,
      isClosable: true,
    });
  }, [toast]);

  return (
    <Flex direction="column" align="center" paddingTop={16} justify="center">
      <Image src={logbookIcon} className={icon} />
      <EmailPasswordInput />
      <Footer />
    </Flex>
  );
};

export default Login;
